export default __webpack_public_path__ + "static/media/pin_map.3e247680.svg";